<template>
    <div class="flex border-t border-b -mb-px border-gray-200 bg-white draggable">
        <div class="flex flex-1" :class="readOnly ? 'truncate' : ''">
            <div
                v-if="readOnly"
                class="flex-1 text-sm -my-px px-2 py-1.5 border border-gray-200 shadow-none relative truncate"
                v-text="item.name"
                :title="item.name"
            ></div>
            <labour-rates-search-dropdown
                v-else
                class="flex-1"
                #default="{ open, opened, query, setQuery }"
                :uom="form.unit_of_measure"
                :current="item.name"
                :labour-rates="labourRates"
                :labour-rate-groups="labourRateGroups"
                @selected="updateLabourRate"
                @created="$emit('new:labour', $event)"
            >
                <input
                    class="text-sm -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20"
                    type="text"
                    ref="description"
                    :value="opened ? query : item.name"
                    :title="item.name"
                    @input="setQuery($event.target.value)"
                    @focus="open"
                >
            </labour-rates-search-dropdown>
        </div>
        <global-specs-form-price-cells
            class="ml-px"
            :item="item"
            :uom="form.unit_of_measure"
            :read-only="readOnly"
            :price.sync="item.price_per_hour"
            :coverage.sync="item.coverage_per_hour"
            :rate.sync="item.price_per_uom"
            @update:price="$emit('updated')"
            @update:coverage="$emit('updated')"
            @update:rate="$emit('updated')"
        >
            <template #price="{ price, updatePrice }">
                <ui-dropdown placement="bottom-start" menu-class="p-3 w-52 flex" class="flex w-full" trigger-class="flex w-full">
                    <template #default="{ open, close }">
                        <estimates-old-page-cell
                            currency
                            class="text-sm text-right -ml-px -my-px px-2 py-1.5 border border-gray-200"
                            placeholder="Price"
                            :read-only="readOnly"
                            :value="price"
                            @change="updatePrice"
                            @mouseenter="open"
                            @mouseleave="close"
                        ></estimates-old-page-cell>
                    </template>
                    <template #menu>
                        <table class="w-full">
                            <tbody>
                                <tr>
                                    <td class="text-gray-600 text-sm">Daily Rate</td>
                                    <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                        {{ item.price_per_day | toCurrency }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-gray-600 text-sm">Hours Per Day</td>
                                    <td class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                                        {{ item.hours_per_day }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </ui-dropdown>
            </template>
        </global-specs-form-price-cells>
        <div class="w-32 -ml-px border-r border-gray-200 bg-gray-50 px-2 py-1.5 text-sm text-right" v-if="showTotal">
            {{ total | toCurrency }}
        </div>
        <div class="w-8 flex-shrink-0 px-1 border-r border-gray-200 flex items-center justify-center">
            <ui-dropdown placement="bottom-end" menu-class="p-3 w-48" v-if="! readOnly">
                <template #default="{ toggle }">
                    <button @click.prevent="toggle" class="text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative p-1 rounded">
                        <i class="fa fa-ellipsis-h"></i>
                    </button>
                </template>

                <template #menu>
                    <ui-dropdown-item icon="fas fa-trash" danger @click.stop="deleteLabourRate">Delete</ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>
import { LabourRate } from '@models'

export default {
    props: {
        form: Object,
        estimate: Object,
        item: Object,
        labourRates: Array,
        labourRateGroups: Array,
        quantity: Number,
        readOnly: Boolean,
    },
    computed: {
        showTotal () {
            return this.quantity !== undefined
        },
        total () {
            return this.item.price_per_uom * this.quantity
        },
    },
    methods: {
        async updateLabourRate (labourRate) {
            this.item.rate = labourRate
            this.item.name = labourRate.full_name
            const prices = await LabourRate.price(labourRate.id, this.estimate?.id)
            this.item.price_per_day = prices.price_per_day
            this.item.price_per_hour = prices.price_per_hour
            this.item.hours_per_day = prices.hours_per_day
            this.item.coverage_per_hour = prices.coverage_per_hour
            this.item.price_per_uom = prices.price_per_uom
            this.$emit('updated')
        },
        deleteLabourRate () {
            this.form.labour = this.form.labour
                .filter(materialLine => materialLine !== this.item)
            this.$emit('updated')
        },
    },
}
</script>
